import { addItemsToCart } from '@theme/cart-add-helper';
import { formatMoney } from '@theme/money-formatting';

class ProductBundle extends HTMLElement {
  connectedCallback() {
    this.checkboxes = Array.from(this.querySelectorAll('[data-bundle-item]'));
    this.addButton = this.querySelector('[data-bundle-add]');
    this.totalEl = this.querySelector('[data-bundle-total]');
    this.compareEl = this.querySelector('[data-bundle-compare]');
    this.saveEl = this.querySelector('.product-bundle__save');
    this.discount = Number(this.dataset.discount) || 0;
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.currency = this.dataset.currency || 'USD';

    this.checkboxes.forEach((cb) => cb.addEventListener('change', this.#update));
    this.addButton?.addEventListener('click', this.#onAdd);
    this.#update();
  }

  disconnectedCallback() {
    this.checkboxes.forEach((cb) => cb.removeEventListener('change', this.#update));
    this.addButton?.removeEventListener('click', this.#onAdd);
  }

  #update = () => {
    let subtotal = 0;
    let checkedCount = 0;
    for (const cb of this.checkboxes) {
      if (cb.checked && cb.dataset.available === 'true') {
        subtotal += Number(cb.dataset.price) || 0;
        checkedCount += 1;
      }
    }

    // A bundle discount only applies to 2+ items bought together, matching how
    // a Shopify "frequently bought together" Automatic Discount actually fires.
    // Showing a discounted total for a single item would imply savings the cart
    // cannot honor, so the discount/compare/badge only appear at 2+ items.
    const discountActive = this.discount > 0 && checkedCount >= 2;
    const discounted = discountActive ? Math.round(subtotal * (1 - this.discount / 100)) : subtotal;

    if (this.totalEl) this.totalEl.textContent = formatMoney(discounted, this.moneyFormat, this.currency);
    if (this.compareEl) {
      this.compareEl.textContent = discountActive ? formatMoney(subtotal, this.moneyFormat, this.currency) : '';
      this.compareEl.hidden = !discountActive;
    }
    if (this.saveEl) this.saveEl.hidden = !discountActive;
    if (this.addButton) this.addButton.disabled = checkedCount === 0;
  };

  #onAdd = async () => {
    const items = this.checkboxes
      .filter((cb) => cb.checked && cb.dataset.available === 'true' && cb.dataset.variantId)
      .map((cb) => ({ id: cb.dataset.variantId, quantity: 1 }));
    if (items.length === 0) return;

    this.addButton.disabled = true;
    try {
      await addItemsToCart(items, 'product-bundle');
    } catch (error) {
      /* helper surfaced the error; re-enable below */
    } finally {
      this.#update();
    }
  };
}

if (!customElements.get('product-bundle')) customElements.define('product-bundle', ProductBundle);
